import { useState } from 'react';
import { Button } from '@mui/material';
import toast from 'react-hot-toast';
import * as styles from './AdministrationForm.css';

type CopyPreviewLinkProps = {
  url: string | null;
};

export const CopyPreviewLink = ({ url }: CopyPreviewLinkProps) => {
  const [showManualCopy, setShowManualCopy] = useState(false);

  const copy = async () => {
    if (!url) return;
    try {
      await navigator.clipboard.writeText(url);
      toast.success('Preview link copied');
    } catch {
      setShowManualCopy(true);
    }
  };

  return (
    <div className={styles.previewLinkRow}>
      <div>
        <Button variant="outlined" disabled={!url} onClick={copy}>
          Copy preview link
        </Button>
      </div>
      {showManualCopy && url ? (
        <input
          readOnly
          aria-label="Landing page preview link"
          className={styles.previewLinkField}
          value={url}
          onFocus={(event) => event.currentTarget.select()}
        />
      ) : null}
    </div>
  );
};
